export default __webpack_public_path__ + "assets/_Chapters/Karriere/AusbildungUndStudium/azubi-und-studi-outtakes-standbild.webp";